.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: var(--radius-md);
  border: 1px solid transparent;
  white-space: nowrap;
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-semibold);
  font-family: var(--font-sans);
  line-height: 1;
  box-shadow: var(--shadow-elevation-1);
  transition:
    background-color var(--motion-fast) ease,
    border-color var(--motion-fast) ease,
    color var(--motion-fast) ease,
    box-shadow var(--motion-fast) ease,
    transform 100ms ease;
}

.button:active {
  transform: scale(0.97);
}

.loaderSlot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.loaderSlotHidden {
  display: none;
}

.content {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.button:disabled {
  opacity: 1;
  pointer-events: none;
  box-shadow: none;
}

.button:focus-visible {
  outline: none;
  box-shadow: var(--focus-ring-shadow);
}

.compact {
  height: 24px;
  padding: 0 8px;
  font-size: var(--font-size-caption);
}

.sm {
  height: 28px;
  padding: 0 12px;
}

.md {
  height: 32px;
  padding: 0 12px;
}

.lg {
  height: 40px;
  padding: 0 16px;
}

.icon {
  width: 28px;
  height: 28px;
  padding: 0;
}

.primary {
  border-color: color-mix(in oklab, var(--foreground) 12%, transparent);
  background: var(--primary);
  color: var(--primary-foreground);
}

.primary:hover {
  background: color-mix(in oklab, var(--primary) 92%, white 8%);
}

.secondary {
  border-color: var(--border);
  background: var(--background);
  color: var(--foreground);
}

.secondary:hover {
  background: var(--background-transparent-light);
}

.outline {
  border-color: var(--border);
  background: var(--background);
  color: var(--foreground);
}

.outline:hover {
  background: var(--tertiary);
}

.ghost {
  border-color: transparent;
  background: transparent;
  color: var(--muted-foreground);
}

.ghost:hover {
  background: var(--background-transparent-light);
  color: var(--foreground);
}

.destructive {
  border-color: var(--destructive);
  background: var(--destructive);
  color: var(--destructive-foreground);
}

.destructive:hover {
  background: color-mix(in oklab, var(--destructive) 92%, white 8%);
}

.primary:disabled,
.secondary:disabled,
.outline:disabled,
.ghost:disabled,
.destructive:disabled {
  background: var(--secondary);
  border-color: var(--background-transparent-lighter);
  color: var(--foreground-tertiary);
}

.link {
  border: 0;
  background: transparent;
  color: var(--primary);
  text-decoration: underline;
  text-underline-offset: 4px;
  padding: 0;
}

.primary.accentBlue {
  background: var(--color-blue);
  border-color: color-mix(in oklab, var(--color-blue) 82%, black 18%);
  color: var(--color-white);
}

.primary.accentBlue:hover {
  background: color-mix(in oklab, var(--color-blue) 90%, black 10%);
}
